import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/52bb30dd-0a73-498d-874f-57d934b0de4c.png" 
              alt="IGANA Logo" 
              className="h-10 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('vpn')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              VPN
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="hidden md:block bg-gradient-to-r from-teal-500 to-teal-600 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:from-teal-600 hover:to-teal-700 transition-all whitespace-nowrap cursor-pointer"
          >
            Get Started
          </button>
        </div>
      </div>
    </nav>
  );
}
